import { render, staticRenderFns } from "./AccordionTransaction.vue?vue&type=template&id=15d63ae2"
import script from "./AccordionTransaction.vue?vue&type=script&lang=js"
export * from "./AccordionTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports